// extracted by mini-css-extract-plugin
export var danger = "_3a-6";
export var lightPink = "_3a-a";
export var medium = "_3a-j";
export var nearSquare = "_3a-m";
export var neutralBlue = "_3a-8";
export var neutralYellow = "_3a-7";
export var noCapitalize = "_3a-1";
export var normal = "_3a-2";
export var pill = "_3a-0";
export var primary = "_3a-3";
export var primaryLight = "_3a-4";
export var shadow = "_3a-n";
export var small = "_3a-k";
export var solidBlack = "_3a-i";
export var solidGreen = "_3a-d";
export var solidLightBlue = "_3a-f";
export var solidNavy = "_3a-e";
export var solidOrange = "_3a-h";
export var solidPink = "_3a-g";
export var solidRed = "_3a-b";
export var solidWhite = "_3a-9";
export var solidYellow = "_3a-c";
export var success = "_3a-5";
export var xsmall = "_3a-l";